import PurchaseHistoryOrderItem from "@/pages/Home/PurchaseHistory/OrderItem";
import { useAppTranslation } from "@/utils";
import { bnplConsumerApis } from "@payping/api";
import { Alert, Divider, Flex, useMessagedAsync } from "@payping/web-components";
import Loading from "@/pages/loading";
import { PPFullColorLogoFa } from "@/core/utils";

const InstallmentLimitReached = () => {
  const { t } = useAppTranslation();

  const listState = useMessagedAsync(
    async () => {
      const res = await bnplConsumerApis.dashboardOrderList(undefined, undefined, 1, undefined, 1000, 1);
      return res;
    },
    [],
    {
      success: false,
      error: true,
    },
  );

  if (listState.loading) {
    return <Loading />;
  }

  return (
    <Flex vertical className="tw:h-full">
      <Flex className="tw:w-full tw:p-5" align="center">
        <img src={PPFullColorLogoFa} width={60} height={24} />
      </Flex>
      <Divider className="tw:m-0!" />
      <Flex vertical className="tw:h-full tw:w-full tw:p-3!">
        <Flex className="tw:mt-1! tw:w-full tw:p-1!" gap="middle" vertical>
          <Alert
            title={null}
            description={
              <Flex vertical gap={"small"}>
                <span>{t("pay.installmentLimitReachedTitle")}</span>
                <span>{t("pay.installmentLimitReachedContent")}</span>
              </Flex>
            }
            type="warning"
            showIcon
          />
        </Flex>
        <Flex className="tw:mt-2! tw:w-full tw:p-1!" gap="middle" vertical>
          {listState.value?.orders.map((item) => (
            <PurchaseHistoryOrderItem key={item.trackingCode} data={item} />
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default InstallmentLimitReached;
